import React from 'react';
import { useLocation } from 'react-router-dom';

type CourseNavToggleType = {
  isNavOpen: boolean;
  toggleNav(): void;
};

export const CourseNavToggle = React.createContext<CourseNavToggleType>({
  isNavOpen: false,
  toggleNav() {},
});

export default function CourseNavToggleProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isNavOpen, setIsNavOpen] = React.useState(window.innerWidth >= 768);
  const { pathname } = useLocation();

  function toggleNav() {
    setIsNavOpen((navState) => !navState);
  }

  // On a phone the nav covers the page, so close it whenever the student
  // moves to another page. This runs as the URL changes rather than when the
  // next page mounts: that page can take a moment to load, and a nav the
  // student opens in the meantime has to stay open.
  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsNavOpen(false);
    }
  }, [pathname]);

  React.useLayoutEffect(() => {
    function handleResize() {
      if (!isNavOpen && window.innerWidth >= 768) {
        setIsNavOpen(true);
      } else if (isNavOpen && window.innerWidth < 768) {
        setIsNavOpen(false);
      }
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isNavOpen]);

  return (
    <CourseNavToggle.Provider
      value={{
        isNavOpen,
        toggleNav,
      }}
    >
      {children}
    </CourseNavToggle.Provider>
  );
}
